import { EmptyRenderer } from "./EmptyRenderer";
import { ErrorRenderer } from "./ErrorRenderer";
import { ExecutionMetricRenderer } from "./ExecutionMetricRenderer";
import { JsonRenderer } from "./JsonRenderer";
import { LinkRenderer } from "./LinkRenderer";
import { MarkdownRenderer } from "./MarkdownRenderer";
import { MediaCollectionRenderer } from "./MediaCollectionRenderer";
import { MediaRenderer } from "./MediaRenderer";
import { MultiContentRenderer } from "./MultiContentRenderer";
import { TextRenderer } from "./TextRenderer";

import { CellContentType, type ClassifiedContent } from "@/routes/smart-table/utils/contentType";

export { CellDiffRenderer } from "./CellDiffRenderer";
export type { CellDiffValue } from "./CellDiffRenderer";

interface CellContentRendererProps {
  content: ClassifiedContent;
  renderLargeJsonAsRaw?: boolean;
}

export default function CellContentRenderer({
  content,
  renderLargeJsonAsRaw = false,
}: CellContentRendererProps) {
  const props = { content };

  switch (content.type) {
    case CellContentType.PLAIN_TEXT:
      return <TextRenderer {...props} />;
    case CellContentType.MARKDOWN:
      return <MarkdownRenderer {...props} />;
    case CellContentType.JSON:
      return <JsonRenderer {...props} renderLargeValueAsRaw={renderLargeJsonAsRaw} />;
    case CellContentType.LINK:
      return <LinkRenderer {...props} />;
    case CellContentType.PRICE:
    case CellContentType.DURATION:
      return <ExecutionMetricRenderer {...props} />;
    case CellContentType.IMAGE:
    case CellContentType.AUDIO:
    case CellContentType.VIDEO:
    case CellContentType.PDF:
    case CellContentType.FILE:
      return <MediaRenderer {...props} />;
    case CellContentType.MEDIA_COLLECTION:
      return <MediaCollectionRenderer {...props} />;
    case CellContentType.MULTI_CONTENT:
      return <MultiContentRenderer {...props} />;
    case CellContentType.ERROR:
      return <ErrorRenderer {...props} />;
    case CellContentType.EMPTY:
      return <EmptyRenderer />;
    default:
      return <TextRenderer {...props} />;
  }
}

export { EmptyRenderer } from "./EmptyRenderer";
export { ErrorRenderer } from "./ErrorRenderer";
export { ExecutionMetricRenderer } from "./ExecutionMetricRenderer";
export { JsonRenderer } from "./JsonRenderer";
export { LinkRenderer } from "./LinkRenderer";
export { MarkdownRenderer } from "./MarkdownRenderer";
export { MediaCollectionRenderer } from "./MediaCollectionRenderer";
export { MediaRenderer } from "./MediaRenderer";
export { MultiContentRenderer } from "./MultiContentRenderer";
export { TextRenderer } from "./TextRenderer";
